'use client';

import Link from 'next/link';

interface NavLink {
  label: string;
  href: string;
}

/* Only public routes - no protected routes that require login */
const navLinks: NavLink[] = [
  { label: 'Home', href: '/' },
  { label: 'Browse courses', href: '/catalog' },
  { label: 'Learning paths', href: '/learning-paths' },
];

export default function NotFound404Page() {
  return (
    <div className="relative">
      <div
        data-swiftype-index="false"
        className="section mx-auto flex max-w-[720px] flex-col items-center justify-center pb-24 text-center font-inter tab:pb-28 desktop:pb-32"
      >
        <h1 className="h1-standard text-text-default-strong max-tab:text-[32px]">
          This page doesn&apos;t exist
        </h1>
        <p className="mt-6 cs-m-body text-text-default-medium leading-relaxed tab:mt-8">
          We can&apos;t find the page you are looking for.
        </p>
        <p className="cs-m-body text-text-default-medium leading-relaxed">
          Please check your URL or browse through this list of our most visited pages and resources.
        </p>

        <nav className="mt-12 flex flex-wrap justify-center gap-x-8 gap-y-4 tab:gap-x-10 desktop:gap-x-12">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              href={link.href}
              className="cs-m-body text-text-default-light underline underline-offset-4 hover:text-text-default-strong transition-colors"
            >
              {link.label}
            </Link>
          ))}
        </nav>
      </div>
      <div className="absolute bottom-0 left-0 -z-10 w-full pointer-events-none">
        <div className="not-found-gradient-box h-[7vw] max-h-[92px] min-h-10 w-[18%] min-w-[98px]" />
        <div className="not-found-gradient-box h-[7vw] max-h-[92px] min-h-10 w-2/5 min-w-[196px]" />
      </div>
    </div>
  );
}
